let fbq: any

export function facebookInit() {
  // @ts-ignore
  if (window.fbq) return;
  // @ts-ignore
  fbq = window.fbq = function() {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments)
  };
  // @ts-ignore
  if (!window._fbq) window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = !0;
  fbq.version = '2.0';
  fbq.queue = [];
  const t = document.createElement('script');
  t.async = !0;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s?.parentNode?.insertBefore(t, s)
}

export { fbq }
